<template>
    <div class="top-chat-header-wrap">
        <div class="main-content">
            <div class="menu-wrap">
                <img class="logo" @click="refreshPage" src="@/assets/home/logo.png" alt="topchat">
                <div class="menu">
                    <div :class="['menu-item',{selectedItem:selectedIndex == item.index}]" 
                        v-for="item in (topChatUserInfo && topChatUserInfo.uid ? loginMenu : menu)" 
                        :key="item.index"
                        @click="changeMenu(item)"
                    >
                        <img class="icon" :src="selectedIndex == item.index ? item.selected : item.normal" alt="">
                        <span class="name">{{item.name}}</span>
                    </div>
                </div>
            </div>
            <div class="user-content">
                <div v-if="topChatUserInfo && topChatUserInfo.uid"  class="userCenterBox">
                    <div class="avatarBox" @mouseenter="showMenu" @mouseleave="hideMenu">
                        <img :class="['avatar',computedVipTime() ? 'a1' : 'a2']" :src="topChatUserInfo.avatar" alt="" />
                        <img class="vipHeaderIcon"  v-if="computedVipTime()" src="@/assets/my/vipMark.png" alt="" />
                        <div class="down-menu" :class="{menuShow : isMenuVisible}">
                            <div class="menuItem" @click="downMenu('my')">
                                <img class="menuIcon" src="./images/userIcon.png" alt="">
                                <span class="menuTitle">个人中心</span>
                            </div>
                            <div class="menuItem" @click="downMenu('logout')">
                                <img class="menuIcon" src="./images/exitIcon.png" alt="">
                                <span class="menuTitle">退出登录</span>
                            </div>
                        </div>
                    </div>
                </div>
                <span class="login" v-else  :class="{'seleLoginStyle':selectedIndex == 4}" @click="menuLogin">登录</span>
                <!-- <SearchInput @changeSearch="changeSearch"></SearchInput> -->
            </div>
        </div>
    </div>
</template>

<script>
import SearchInput from '@/tool/headSearch.vue'
import { mapState } from 'vuex'
export default {
    name: "top-chat-header",
    watch:{
        $route(to,form){
            let _index = this.menuUrlArr.indexOf(to.path)
            this.setLocalStorage(_index)
        }
    },
    computed:{
        ...mapState(['topChatUserInfo'])
    },
    data() {
        return {
            menuIndexArr:[0,1,2,3],
            menuUrlArr:['/','/chat','/find','/my','/login'],
            selectedIndex:localStorage.getItem('selectedIndex') || 0,
            isMenuVisible: false, // 是否显示下拉菜单
            menu:[
                {
                    name:"首页",
                    index:0,
                    url:'/',
                    normal: require('./images/home1.png'),
                    selected: require('./images/home2.png')
                },
                {
                    name:"聊天",
                    index:1,
                    url:'/chat',
                    normal: require('./images/chat1.png'),
                    selected: require('./images/chat2.png')
                },
                {
                    name:"发现",
                    index:2,
                    url:'/find',
                    normal: require('./images/find1.png'),
                    selected: require('./images/find2.png')
                },
            ],
            loginMenu:[
                {
                    name:"首页",
                    index:0,
                    url:'/',
                    normal: require('./images/home1.png'),
                    selected: require('./images/home2.png')
                },
                {
                    name:"聊天",
                    index:1,
                    url:'/chat',
                    normal: require('./images/chat1.png'),
                    selected: require('./images/chat2.png')
                },
                {
                    name:"发现",
                    index:2,
                    url:'/find',
                    normal: require('./images/find1.png'),
                    selected: require('./images/find2.png')
                },
                {
                    name:"我的",
                    index:3,
                    url:'/my',
                    normal: require('./images/my1.png'),
                    selected: require('./images/my2.png')
                } 
            ],
            userInfo: JSON.parse(localStorage.getItem('topChatUserInfo')) || {}
        }
    },
    components:{
        SearchInput
    },
    methods:{
        downMenu(type){
            this.isMenuVisible = false;
            if(type == 'my'){
                this.$openChatRouter({
                    path: '/my',
                })
            }else if(type == 'logout'){
                this.$cookie.delete("token");
                localStorage.clear()
                this.$openChatRouter({
                    path: '/',
                })
                location.reload()
            }
        },
        changeMenu(item){
            this.setLocalStorage(item.index)
            this.$openChatRouter({
                path: item.url,
            })
        },
        refreshPage(){
            window.location.reload();
        },
        changeSearch(value){
        },
        setLocalStorage(value){
            this.selectedIndex = value;
            localStorage.setItem('selectedIndex',value)
        },
        menuLogin(){
            this.setLocalStorage(4);
            this.$openChatRouter({
                path: '/login',
            })
        },
        showMenu() {
            // 鼠标移入时显示下拉菜单
            this.isMenuVisible = true;
        },
        hideMenu() {
            // 鼠标移出时隐藏下拉菜单
            this.isMenuVisible = false;
        },
        computedVipTime(){
            if(this.topChatUserInfo.vipTime){
                return this.topChatUserInfo.vipTime > new Date().valueOf();
            }else{
                return false;
            }
        }
    },
    mounted(){
        let _index = this.menuUrlArr.indexOf(this.$route.path)
        this.setLocalStorage(_index)
    }
};
</script>

<style lang="less">
@import './header';
</style>